let loadPromise = null;

export function loadHalyk() {
  if (typeof window === "undefined") {
    return Promise.reject(new Error("halyk is browser-only"));
  }
  if (window.halyk) return Promise.resolve(window.halyk);
  if (loadPromise) return loadPromise;

  const scriptUrl = window.__CONFIG__?.VUE_APP_HALYK_SCRIPT_URL;
  if (!scriptUrl) {
    return Promise.reject(
      new Error("VUE_APP_HALYK_SCRIPT_URL is not set in public/config.js")
    );
  }

  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = scriptUrl;
    script.async = true;
    script.onload = () => {
      if (window.halyk) {
        resolve(window.halyk);
      } else {
        loadPromise = null;
        reject(new Error("halyk script loaded but window.halyk is missing"));
      }
    };
    script.onerror = () => {
      loadPromise = null;
      reject(new Error("failed to load halyk payment-api.js"));
    };
    document.head.appendChild(script);
  });

  return loadPromise;
}

export function payWithHalyk(paymentObject, onClose = () => {}) {
  if (!window.halyk?.showPaymentWidget) {
    throw new Error("halyk is not loaded — call loadHalyk() first");
  }
  // Halyk вызывает onClose при закрытии виджета; дефолтный no-op — чтобы не падало без колбэка.
  window.halyk.showPaymentWidget(paymentObject, onClose);
}
